import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '@app/shared/config/app.config';
import { IBillingPeriods } from '@app/shared/models/colletion.model';
import { IDtoResponse } from '@app/shared/models/dtos/response.dto';
import { map, Observable } from 'rxjs';
import { ServiceBase } from '../base/base.service';
import { PATH } from '@app/shared/types/enums/path';
import { ActionEnum } from '@app/shared/types/enums/ActionEnum.enum';

@Injectable({
  providedIn: 'root',
})
export class CollectionService extends ServiceBase {
  constructor(private readonly http: HttpClient) {
    super(`${APP_CONFIG.serviceBaseUrl}/collection/api/v1/collection`);
  }

  getBillingPeriods(contractCode: string, year: string, month: string): Observable<IBillingPeriods[] | undefined> {
    const headers = new HttpHeaders().set('monitoring_view', PATH.CREDIT).set('monitoring_action', ActionEnum.READ);

    return this.http
      .get<IDtoResponse<IBillingPeriods[]>>(`${this.baseUrl}/contract/${contractCode}/bill-periods?year=${year}&month=${month}`, {
        headers,
      })
      .pipe(map(response => response.data));
  }
}
